// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.writing-coach {
  padding: 20px;
  max-width: 1100px;
  margin: 0 auto;
}

.writing-coach h1 {
  font-size: 24px;
  margin-bottom: 6px;
}

.writing-coach-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.writing-coach-ai-tag {
  border-radius: 999px;
  padding: 4px 9px;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 12px;
  font-weight: 700;
}

.writing-coach .subtitle {
  color: #666;
  margin-bottom: 20px;
}

/* Upload Area */
.upload-area {
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
  background: #f8fafc;
}

.upload-area:hover {
  border-color: #2563eb;
  background: #eff6ff;
}

.upload-area.dragover {
  border-color: #2563eb;
  background: #dbeafe;
}

.upload-icon {
  font-size: 48px;
  margin-bottom: 12px;
}

.upload-area p {
  margin: 4px 0;
  color: #64748b;
}

.upload-area .formats {
  font-size: 12px;
  color: #94a3b8;
}

/* Preview + Results Layout */
.coach-layout {
  display: flex;
  gap: 20px;
  margin-top: 20px;
}

.preview-section {
  flex: 1;
  min-width: 0;
}

.results-section {
  flex: 1;
  min-width: 0;
}

/* Preview */
.preview-box {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 16px;
  background: #fff;
  max-height: 500px;
  overflow: auto;
}

.preview-box img {
  max-width: 100%;
  border-radius: 8px;
}

.preview-box .extracted-text {
  margin-top: 12px;
  padding: 12px;
  background: #f1f5f9;
  border-radius: 8px;
  font-family: monospace;
  font-size: 14px;
  white-space: pre-wrap;
  line-height: 1.6;
}

/* Results */
.results-box {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 16px;
  background: #fff;
  max-height: 500px;
  overflow: auto;
}

.correction-item {
  padding: 12px;
  margin-bottom: 12px;
  border-radius: 8px;
  border-left: 4px solid #ef4444;
  background: #fef2f2;
}

.correction-item .original {
  text-decoration: line-through;
  color: #ef4444;
  font-weight: 500;
}

.correction-item .suggested {
  color: #16a34a;
  font-weight: 600;
  margin-left: 8px;
}

.correction-item .explanation {
  display: block;
  margin-top: 6px;
  font-size: 13px;
  color: #475569;
}

.alternative-item {
  padding: 12px;
  margin-bottom: 12px;
  border-radius: 8px;
  border-left: 4px solid #2563eb;
  background: #eff6ff;
}

.alternative-item .alt-label {
  font-size: 12px;
  color: #2563eb;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.alternative-item .alt-text {
  color: #1e40af;
}

/* Status Messages */
.status-message {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px;
  border-radius: 8px;
  background: #f1f5f9;
  color: #475569;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 3px solid #e2e8f0;
  border-top-color: #2563eb;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Buttons */
.coach-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s;
}

.coach-btn.primary {
  background: #2563eb;
  color: white;
}

.coach-btn.primary:hover {
  background: #1d4ed8;
}

.coach-btn.primary:disabled {
  background: #93c5fd;
  cursor: not-allowed;
}

.coach-btn.secondary {
  background: #e2e8f0;
  color: #334155;
}

.coach-btn.secondary:hover {
  background: #cbd5e1;
}

.actions-bar {
  display: flex;
  gap: 10px;
  margin-top: 12px;
}

/* Overall summary */
.summary-box {
  padding: 14px;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 8px;
  margin-bottom: 16px;
}

.summary-box h3 {
  margin: 0 0 4px 0;
  color: #166534;
  font-size: 15px;
}

.summary-box p {
  margin: 0;
  color: #15803d;
  font-size: 13px;
}

/* Responsive */
@media (max-width: 768px) {
  .coach-layout {
    flex-direction: column;
  }
}


/* Line numbers in extracted text */
.text-line {
  display: flex;
  gap: 10px;
  padding: 2px 0;
  line-height: 1.6;
}

.text-line .line-number {
  color: #94a3b8;
  font-size: 12px;
  min-width: 24px;
  text-align: right;
  user-select: none;
  flex-shrink: 0;
}

/* Line badge in corrections */
.line-badge {
  display: inline-block;
  background: #fecaca;
  color: #991b1b;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
  margin-bottom: 4px;
}

.line-badge.alt {
  background: #bfdbfe;
  color: #1e40af;
}
`, "",{"version":3,"sources":["webpack://./src/features/WritingCoach/writingCoach.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA,YAAY;AACZ;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;EACxB;AACF;;;AAGA,mCAAmC;AACnC;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".writing-coach {\n  padding: 20px;\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n.writing-coach h1 {\n  font-size: 24px;\n  margin-bottom: 6px;\n}\n\n.writing-coach-title-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.writing-coach-ai-tag {\n  border-radius: 999px;\n  padding: 4px 9px;\n  background: #e0f2fe;\n  color: #0369a1;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.writing-coach .subtitle {\n  color: #666;\n  margin-bottom: 20px;\n}\n\n/* Upload Area */\n.upload-area {\n  border: 2px dashed #cbd5e1;\n  border-radius: 12px;\n  padding: 40px;\n  text-align: center;\n  cursor: pointer;\n  transition: border-color 0.2s, background 0.2s;\n  background: #f8fafc;\n}\n\n.upload-area:hover {\n  border-color: #2563eb;\n  background: #eff6ff;\n}\n\n.upload-area.dragover {\n  border-color: #2563eb;\n  background: #dbeafe;\n}\n\n.upload-icon {\n  font-size: 48px;\n  margin-bottom: 12px;\n}\n\n.upload-area p {\n  margin: 4px 0;\n  color: #64748b;\n}\n\n.upload-area .formats {\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n/* Preview + Results Layout */\n.coach-layout {\n  display: flex;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.preview-section {\n  flex: 1;\n  min-width: 0;\n}\n\n.results-section {\n  flex: 1;\n  min-width: 0;\n}\n\n/* Preview */\n.preview-box {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 16px;\n  background: #fff;\n  max-height: 500px;\n  overflow: auto;\n}\n\n.preview-box img {\n  max-width: 100%;\n  border-radius: 8px;\n}\n\n.preview-box .extracted-text {\n  margin-top: 12px;\n  padding: 12px;\n  background: #f1f5f9;\n  border-radius: 8px;\n  font-family: monospace;\n  font-size: 14px;\n  white-space: pre-wrap;\n  line-height: 1.6;\n}\n\n/* Results */\n.results-box {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 16px;\n  background: #fff;\n  max-height: 500px;\n  overflow: auto;\n}\n\n.correction-item {\n  padding: 12px;\n  margin-bottom: 12px;\n  border-radius: 8px;\n  border-left: 4px solid #ef4444;\n  background: #fef2f2;\n}\n\n.correction-item .original {\n  text-decoration: line-through;\n  color: #ef4444;\n  font-weight: 500;\n}\n\n.correction-item .suggested {\n  color: #16a34a;\n  font-weight: 600;\n  margin-left: 8px;\n}\n\n.correction-item .explanation {\n  display: block;\n  margin-top: 6px;\n  font-size: 13px;\n  color: #475569;\n}\n\n.alternative-item {\n  padding: 12px;\n  margin-bottom: 12px;\n  border-radius: 8px;\n  border-left: 4px solid #2563eb;\n  background: #eff6ff;\n}\n\n.alternative-item .alt-label {\n  font-size: 12px;\n  color: #2563eb;\n  font-weight: 600;\n  text-transform: uppercase;\n  margin-bottom: 4px;\n}\n\n.alternative-item .alt-text {\n  color: #1e40af;\n}\n\n/* Status Messages */\n.status-message {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 16px;\n  border-radius: 8px;\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.spinner {\n  width: 20px;\n  height: 20px;\n  border: 3px solid #e2e8f0;\n  border-top-color: #2563eb;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Buttons */\n.coach-btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background 0.2s;\n}\n\n.coach-btn.primary {\n  background: #2563eb;\n  color: white;\n}\n\n.coach-btn.primary:hover {\n  background: #1d4ed8;\n}\n\n.coach-btn.primary:disabled {\n  background: #93c5fd;\n  cursor: not-allowed;\n}\n\n.coach-btn.secondary {\n  background: #e2e8f0;\n  color: #334155;\n}\n\n.coach-btn.secondary:hover {\n  background: #cbd5e1;\n}\n\n.actions-bar {\n  display: flex;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n/* Overall summary */\n.summary-box {\n  padding: 14px;\n  background: #f0fdf4;\n  border: 1px solid #bbf7d0;\n  border-radius: 8px;\n  margin-bottom: 16px;\n}\n\n.summary-box h3 {\n  margin: 0 0 4px 0;\n  color: #166534;\n  font-size: 15px;\n}\n\n.summary-box p {\n  margin: 0;\n  color: #15803d;\n  font-size: 13px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .coach-layout {\n    flex-direction: column;\n  }\n}\n\n\n/* Line numbers in extracted text */\n.text-line {\n  display: flex;\n  gap: 10px;\n  padding: 2px 0;\n  line-height: 1.6;\n}\n\n.text-line .line-number {\n  color: #94a3b8;\n  font-size: 12px;\n  min-width: 24px;\n  text-align: right;\n  user-select: none;\n  flex-shrink: 0;\n}\n\n/* Line badge in corrections */\n.line-badge {\n  display: inline-block;\n  background: #fecaca;\n  color: #991b1b;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 10px;\n  margin-bottom: 4px;\n}\n\n.line-badge.alt {\n  background: #bfdbfe;\n  color: #1e40af;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
